import { render } from "./Layout.vue?vue&type=template&id=464095fc&ts=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import "./Layout.vue?vue&type=style&index=0&id=464095fc&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\e394cd1ec4c7054f\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__